import {effect, Effect} from '@mazechazer/redux-loop'

export type Key = 'session'

export function set <T>(key: Key, value: string, action: T): Effect<T> {
    return effect(() => {
        localStorage.setItem(key, value)
        return Promise.resolve(action)
    })
}

export function remove<T>(key: Key, action: T): Effect<T> {
    return effect(() => {
        localStorage.removeItem(key)
        return Promise.resolve(action)
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/LocalStorage.ts